<template>
  <div>
    <!-- Page content -->
    <b-container>
      <b-row class="justify-content-center mt-5 mb-5">
        <b-col lg="5" md="7">
          <b-card no-body>
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <div class="auth-logo">
                  <img src="@/assets/img/moolah-icon-blue-lg.png" />
                </div>
                <small>Sign in with your credentials.</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    class="mb-3"
                    name="email"
                    ref="email"
                    mode="lazy"
                    prepend-icon="fa-solid fa-envelope"
                    placeholder="Email"
                    v-model="model.email"
                  >
                  </base-input>

                  <base-input
                    class="mb-3"
                    name="password"
                    ref="password"
                    mode="lazy"
                    :rules="{ required: true, min: 8 }"
                    prepend-icon="fa-solid fa-lock"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>

                  <b-form-checkbox v-model="model.rememberMe"
                    >Remember me</b-form-checkbox
                  >

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-block font-weight-bold"
                      >Sign in</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-4">
            <b-col cols="12">
              <small
                ><router-link to="/reset" class="text-muted"
                  >Forgot password?</router-link
                ></small
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  title: "Login",
  inject: ["systemContextService"],
  data() {
    return {
      logo: null,
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  created() {
    this.logo = this.systemContextService.getSystem().dashboardImageUrl;
  },
  mounted() {
    var self = this;

    self.$localStorageService.clearToken();

    this.model.rememberMe =
      this.$localStorageService.getItem("rememberMe") === "true";

    if (this.$localStorageService.getItem("rememberMe") === "true") {
      this.model.email = this.$localStorageService.getItem("email");
      this.$refs.password.$el.querySelector("input").focus();
    } else {
      this.$refs.email.$el.querySelector("input").focus();
    }

    this.$emitter.on("response-validationErrors", (e) => {
      self.$refs.formValidator.setErrors(e.errors);
    });
  },
  methods: {
    async onSubmit() {
      let response = await this.$client.post("/api/auth/login", this.model);
      if (response.data.isSuccess) {
        var loginDto = response.data.value;

        this.$localStorageService.setItem("name", loginDto.userFirstLastName);

        this.$localStorageService.setItem("email", loginDto.userEmail);

        this.$localStorageService.setItem("businessId", loginDto.businessId);

        this.$localStorageService.setItem(
          "poyntAppId",
          loginDto.appId //todo this is now in poynt settings configuration on the server
        );

        this.$localStorageService.setItem("rememberMe", this.model.rememberMe);

        this.$localStorageService.setItem("companyName", loginDto.companyName);

        this.$localStorageService.setItem(
          "companyPhone",
          loginDto.companyPhone
        );

        this.$localStorageService.setItem(
          "companyPhone",
          loginDto.companyPhone
        );

        this.$localStorageService.setItem(
          "lastViewedCompanyNotification",
          loginDto.lastViewedCompanyNotification
        );

        this.$localStorageService.setItem("version", loginDto.version);

        this.$localStorageService.setItem(
          "releaseVersion",
          loginDto.releaseVersion
        );

        this.$localStorageService.setItem("avatar", loginDto.avatar);

        this.$localStorageService.setItem("email", this.model.email);

        this.$localStorageService.removeItem("terminals");

        this.$localStorageService.setItem(
          "system",
          JSON.stringify(loginDto.system)
        );

        this.$localStorageService.setItem(
          "config",
          JSON.stringify({ roles: loginDto.roles })
        );

        var tokenObj = {
          access_token: response.data.value.token,
          refresh_token: response.data.value.refreshToken,
        };

        this.$localStorageService.setToken(tokenObj);

        var jwtToken = this.$jwtDec.decode(tokenObj.access_token);

        this.$localStorageService.setItem("companyId", jwtToken.companyId);

        var adminRole = jwtToken.role.find((e) => e == "Admin");

        this.$localStorageService.setItem("isAdmin", adminRole ? true : false);

        if (this.$route.query.nextUrl) {
          this.$router.push({ path: this.$route.query.nextUrl });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
};
</script>
<style lang="scss"></style>
